// The role inside the admin login token ("ROLE_ADMIN" or "ROLE_SUPPORT"). Only used to
// decide what the dashboard shows — the backend enforces what each role may do.
export const roleFromToken = (token?: string | null): string | null => {
	if (!token) return null;
	try {
		const part = token.split(".")[1];
		const json = atob(part.replace(/-/g, "+").replace(/_/g, "/"));
		return JSON.parse(json)?.role ?? null;
	} catch {
		return null;
	}
};

export const isHelpDesk = (token?: string | null) => roleFromToken(token) === "ROLE_SUPPORT";
